import MapStandalone from "@/pages/map-standalone/index";
import BaseApp from "../modules/base-app";

const MapStandaloneApp = (props) => (
  <BaseApp>
    <MapStandalone {...props} />
  </BaseApp>
);

export default MapStandaloneApp;
